module.exports = __webpack_public_path__ + "img/MM.a316c417.png";